import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Select, { components } from 'react-select';
import { groupSelect } from 'Common/styles/style';
import { VULNS_GROUP_BY_KEYS } from 'store/Filters/constants';
import { selectGroupBy } from 'store/Filters/selectors';
import { setGroupByVulns, clearGroupByVulns } from 'store/Manage/filterActions';
import { FormattedMessage } from 'react-intl';

class GroupFieldSelector extends Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  render () {
    const {
      group_by,
      setGroupBy,
      clearGroupBy
    } = this.props;

    const alias = 'group';

    const SingleValue = ({ children, ...props }) => (
      components.SingleValue && (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <components.SingleValue { ...props }>
        {`Group By: ${children}`}
      </components.SingleValue>
      )
    );

    const options = VULNS_GROUP_BY_KEYS;

    return (
      <div className="mr-26">
        <Select
          styles={ groupSelect }
          isSearchable={ false }
          disabled={ false }
          value={ options.filter((opt) => opt.value === group_by) }
          components={ { SingleValue } }
          placeholder={ <FormattedMessage id={ `${alias}.placeholder` } /> }
          onChange={ (e) => {
            if (e.value.length > 0) {
              setGroupBy(e.value);
            } else {
              clearGroupBy();
            }
          } }
          options={ options.filter((opt) => opt.value !== group_by) }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  group_by: selectGroupBy('vulns', state),
  parsed: state.manage.parsed,
  rowsPerPage: state.manage.rowsPerPage
});

const mapDispatchToProps = (dispatch) => ({
  setGroupBy: (group_by) => {
    dispatch(setGroupByVulns(group_by));
  },
  clearGroupBy: () => {
    dispatch(clearGroupByVulns());
  }
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(GroupFieldSelector));
